export const SESSION_STORAGE_LEFT_MENU_DRAWER = 'leftMenuDrawer';
